import { floorplannerStore } from "../../../store/floorplannerStore";
import {
  collectUsedWallpapers,
  type UsedWallpaperOption,
} from "./collectUsedWallpapers";

/**
 * Scans live walls for product wallpapers already used in the open plan.
 * Must be called from an `observer` render (or MobX reaction) so map /
 * dictionary updates re-run the scan.
 */
export function collectUsedWallpapersFromPlan(): UsedWallpaperOption[] {
  const surfaceRefs: Array<{
    source?: string | null;
    id?: string | null;
    imageUrl?: string | null;
  } | null | undefined> = [];

  floorplannerStore.wallsMap.forEach((wall) => {
    surfaceRefs.push(wall.threeD?.surfaceRef);
  });

  return collectUsedWallpapers({
    surfaceRefs,
    dictionary: floorplannerStore.catalogDictionary.productsById,
  });
}
